import getVisitorId from 'mex_components/app/scripts/storage/getVisitorId';
import getClientId from 'mex_components/app/scripts/storage/getClientId';


const pickListSelectionTracking = (subscriptionFilter, element) => {
  var btn = subscriptionFilter.querySelector('button');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'buybox_picklistSelection',
    picklist_button_text: btn.innerText,
    picklist_selection_text: element.innerText,
    visitor_id: getVisitorId(),
    client_id: getClientId()
  });
};


export default function(){
  const subscriptonFilter = document.querySelector('.buy-box-subscription-filter');
  var options = subscriptonFilter.querySelectorAll('.dropdown__option');
  options.forEach(el => {
    el.addEventListener('click', () => pickListSelectionTracking(subscriptonFilter, el));
  });
}
